<template>
  <div>
    <v-dialog
      v-model="show"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11" class="text-left">
              <h2 class="text-h5">Add your email address</h2>
            </v-col>
            <v-col cols="1">
              <v-icon class="close" color="black" @click.stop="closeDialog">{{
                icons.mdiClose
              }}</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider />
        <v-card-text v-if="show" class="crud-card-text">
          <v-container class="pa-0 person-dialog-form-container">
            <v-row no-gutters>
              <v-col cols="12">
                <p class="mb-4">
                  Add an email address to your account so we can keep your
                  details up to date.
                </p>
                <ValidationObserver ref="observer">
                  <v-form class="modal-form">
                    <v-row>
                      <v-col cols="12" class="pb-0">
                        <ValidationProvider
                          id="email"
                          v-slot="{ errors }"
                          name="email"
                          rules="required|email"
                        >
                          <v-text-field
                            v-model.trim="email"
                            label="Email"
                            :error-messages="errors"
                          />
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-form>
                </ValidationObserver>
              </v-col>
            </v-row>
          </v-container>
          <div class="crud-card-actions pb-0">
            <div class="button-container">
              <GradientButton
                :title="'Save'"
                :small="true"
                :callout="'right'"
                :loading="buttonLoading"
                @gradientButtonClicked="save"
              />
              <GradientButton
                :title="`Ask me later`"
                :small="true"
                :fill="false"
                :callout="'right'"
                @gradientButtonClicked="closeDialog"
              />
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <ErrorSnackbar v-model="showError" :error="errorMessage" />
  </div>
</template>

<script>
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';
  import { UPDATE_USER_MUTATION } from '../../constants/graphql/users';

  export default {
    name: 'TebaEmailDialog',
    components: {
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      value: { type: Boolean },
    },
    data() {
      return {
        email: null,
        errorMessage: null,
      };
    },
    computed: {
      show: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
    },
    methods: {
      closeDialog() {
        this.show = false;
        this.buttonLoading = false;
        this.$emit('tebaEmailModalClosed');
      },
      async save() {
        const isValid = await this.$refs.observer.validate();
        if (!isValid) return;

        this.buttonLoading = true;

        const userInputDetails = {
          email: this.email,
        };
        const id = this.userId;

        this.$apollo
          .mutate({
            mutation: UPDATE_USER_MUTATION,
            variables: {
              id,
              userInputDetails,
            },
          })
          .then(_response => {
            this.$emit('emailSaved');
            this.show = false;
            this.buttonLoading = false;
          })
          .catch(error => {
            this.buttonLoading = false;
            if (error.message.includes('GraphQL error:')) {
              this.errorMessage = error.message
                .replace('GraphQL error:', '')
                .trim();
            } else {
              this.errorMessage = 'Something went wrong. Please try again.';
            }
            this.showError = true;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .button-container {
    gap: 12px;
    margin-bottom: 0px;
  }
</style>
